<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import type { Data } from '~~/server/api/forms/form'

export interface PagesOnlineServicesHeaderProps {
    data: Data
}
const props = defineProps<PagesOnlineServicesHeaderProps>()
</script>
<template>
  <h1
    v-if="props.data.title"
    class="mb-1 mt-lg-10"
  >
    {{ props.data.title }}
  </h1>
  <p
    v-if="props.data.subtitle"
    class="delta mb-2 fw-bolder"
  >
    {{ props.data.subtitle }}
  </p>
  <Typo>
    <div v-html="props.data.description" />
  </Typo>
</template>
